import { DragEndEvent } from '@dnd-kit/core';
import { useCallback } from 'react';
import { DroppableData, NodeType } from '../types';
import { useSaveGanttDropTaskMutation } from '../../../../../queryHooks/productionPlanHooks';
import { GanttDraggableData } from './useGanttDraggable';

export const useGanttOnDragEnd = () => {
  const saveDropTaskMutation = useSaveGanttDropTaskMutation();

  const onDragEnd = useCallback(
    (evt: DragEndEvent) => {
      if (evt.over) {
        const { id: droppedTaskId } = evt.active;
        const data = evt.active.data.current as GanttDraggableData | undefined;
        const current = evt.over.data.current as DroppableData | undefined;

        const isTheSameTask = current?.predecessorTaskId === Number(droppedTaskId);

        if (current && !isTheSameTask) {
          saveDropTaskMutation.mutate({
            taskId: Number(droppedTaskId),
            queueId: current.queueId,
            predecessorTaskId: current.predecessorTaskId,
            type: data?.type ?? NodeType.TASK,
          });
        }
      }
    },
    [saveDropTaskMutation],
  );

  return onDragEnd;
};
